/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";

const __vue_script__ = {
  components: {
    full_loading: full_loading,
  },
  name: "login_widget",
  props: {},
  data: function () {
    return {
      global,
      helper,
      frappe,
      loading: false,
      mobile: "",
      password: "",
      error: false,
      phone_error: false,
      exceptions: [],
      message: "",
      form_sent: false,
      form_disable: false,
      otp_sent: false,
      wrong_otp: false,
      otp: "",
      t_sid: null
    };
  },
  methods: {
    verify_form: function () {
      this.error = false;
      return !this.error;
    },
    isUserExist: async function () {
      global.emitter.emit("show-full-loading");
      this.loading = true;
      try {
        let params = {
          phone_number: this.mobile,
        };
        let res = await $.ajax({
          headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
          url: "/api/method/maalek.api.is_user_exist",
          type: "GET",
          data: params, //for GET request
          // data: JSON.stringify(params) //for POST request
        });
        if (res.message == false) {
          this.phone_error = true;
          this.loading = false;
          global.emitter.emit("hide-full-loading");
          helper.showException("User not found");
          return false;
        }
        this.phone_error = false;
        this.loading = false;
        global.emitter.emit("hide-full-loading");
        return true;
      } catch (error) {
        this.phone_error = true;
        this.loading = false;
        global.emitter.emit("hide-full-loading");
        this.exceptions = helper.showException(error);
        return false;
      }
    },
    sendPhoneVerification: async function () {
      if(this.mobile.length < 10 || ! /^\d+$/.test(this.mobile) || this.mobile.substring(0,2) != "05"){
        this.phone_error = true;
        helper.showException("Wrong user/mobile number");
        return;
      }
      if (this.loading || !this.verify_form()) return;
      if (!(await this.isUserExist())) {
        this.error = true;
        return;
      }
      this.loading = true;
      let params = {
          mobile_no : "+966" + this.mobile.substring(1, this.mobile.length)
      };
      try {
          let res = await $.ajax({
              headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
              url: "/api/method/maalek.api.twilio_api.send_otp",
              type: "GET",
              data: params //for GET request
              // data: JSON.stringify(params) //for POST request
          });
          this.t_sid = res.message;
          this.form_disable = true;
          this.otp_sent = true;
          this.loading = false;
      } catch (e) {
          console.log(e);
          this.loading = false;
          this.otp_sent = false;
          this.form_disable = false;
          var exceptions = helper.showException(e);
      }
    },
    confirm_otp_and_login: async function () {
      this.loading = true;
      try {
        let params = {
          usr: this.mobile,
          t_sid: this.t_sid,
          otp: this.otp,
        };
        let res = await $.ajax({
          headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
          url: "/api/method/maalek.api.login_regular",
          type: "GET",
          data: params, //for GET request
          // data: JSON.stringify(params) //for POST request
        });
        console.log(res);
        if (res.full_name != null && res.full_name != "") {
          localStorage.clear();
          // window.location.reload();
          window.location.replace(document.referrer);
          return;
        }
        this.message = res.message;
        this.loading = false;
        this.error = true;
      } catch (e) {
        console.log("failed");
        console.log(e);
        this.loading = false;
        this.error = true;
        this.message = helper.t("There is something wrong");
        this.exceptions = helper.showException(e);
      }
    },
  },
  mounted() {
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-form-content log-in" },
    [
      _c("h3", [_vm._v(_vm._s(_vm.helper.t("Sign In")))]),
      _vm._v(" "),
      !_vm.loading
        ? _c("form", { staticClass: "user-form" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.mobile,
                        expression: "mobile"
                      }
                    ],
                    staticClass: "form-control border-radius",
                    class: _vm.phone_error ? "error" : "",
                    attrs: {
                      type: "text",
                      name: "user-name",
                      placeholder: "05xxxxxxxx",
                      maxlength: "10",
                      autocomplete: "on",
                      disabled: _vm.loading || _vm.otp_sent
                    },
                    domProps: { value: _vm.mobile },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.sendPhoneVerification()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.mobile = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.helper.t(_vm.message)))
              ]),
              _vm._v(" "),
              !_vm.loading && _vm.otp_sent
                ? _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.otp,
                          expression: "otp"
                        }
                      ],
                      staticClass: "form-control border-radius",
                      attrs: {
                        type: "text",
                        placeholder: _vm.helper.t("Enter OTP here")
                      },
                      domProps: { value: _vm.otp },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.confirm_otp_and_login()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.otp = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("p", [
                    _vm._v(" " + _vm._s(_vm.helper.t("Please wait")) + " ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.wrong_otp
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.helper.t(
                            "Unable to verify OTP! Please try again."
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading && !_vm.otp_sent
                ? _c("div", { staticClass: "col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn default-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.sendPhoneVerification()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.helper.t("Send OTP")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading && _vm.otp_sent
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.helper.t("Enter the OTP sent on {0}", [
                            _vm.mobile
                          ])
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading && _vm.otp_sent
                ? _c("div", { staticClass: "btn-style-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn default-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.confirm_otp_and_login()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.helper.t("Login")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("center", [_vm._v(_vm._s(_vm.helper.t("Please wait")))])
        : _vm._e()
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0b2b046d_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"login-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/login-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__